<template>
	<v-container>
		<PageTitle icon="mdi-calendar" main="Agendamentos" sub="" />

		<v-row class="mb-4">
			<v-col cols="12">
				<v-card flat class="grey lighten-5">
					<v-card-text class="pa-4">
						<v-row align="center">
							<v-col cols="12" md="8">
								<div class="d-flex align-center">
									<div class="mr-6">
										<div class="text-h6 font-weight-regular">{{ folgas.length }}</div>
										<div class="text-caption grey--text">Folgas Programadas</div>
									</div>

									<v-divider vertical class="mx-4"></v-divider>

									<div class="mr-6">
										<div class="text-h6 font-weight-regular">{{ ferias.length }}</div>
										<div class="text-caption grey--text">Férias Agendadas</div>
									</div>

									<v-divider vertical class="mx-4"></v-divider>

									<div>
										<div class="text-h6 font-weight-regular">{{ totalAbatimentosSalario }}</div>
										<div class="text-caption grey--text">Abatimentos Salariais</div>
									</div>
								</div>
							</v-col>

							<v-col cols="12" md="4" class="text-right" v-if="temPermissaoAgendamentos">
								<v-btn @click="openCreateDialog" color="primary">
									<v-icon left>mdi-plus</v-icon>
									Novo Agendamento
								</v-btn>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="dialog" max-width="600">
			<v-card>
				<v-card-title class="primary white--text">
					<v-icon left color="white">mdi-calendar-plus</v-icon>
					{{ dialogTitle }}
				</v-card-title>

				<v-card-text class="pa-4">
					<v-form ref="form" lazy-validation>
						<v-select label="Tipo" 
						:items="tipos" 
						v-model="form.tipo" 
						:disabled="isDisabled" 
						outlined 
						dense 
						item-text="text" 
						item-value="value" 
						:rules="[v => !!v || 'Selecione um tipo']"
						/>

						<v-row v-if="form.tipo">
							<v-col cols="6">
								<v-menu v-model="menuInicio" :close-on-content-click="false" offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										v-model="form.data_inicio"
										:label="form.tipo === 'Ferias' ? 'Início' : 'Data'"
										readonly
										v-bind="attrs"
										v-on="on"
										outlined
										dense
										:rules="[v => !!v || 'Informe a data de início']"
										/>
									</template>
									<v-date-picker v-model="form.data_inicio" @input="menuInicio = false" />
								</v-menu>
							</v-col>

							<v-col cols="6" v-if="form.tipo === 'Ferias'">
								<v-menu v-model="menuFim" :close-on-content-click="false" offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
										v-model="form.data_fim"
										label="Fim"
										readonly
										v-bind="attrs"
										v-on="on"
										outlined
										dense
										:rules="[v => form.tipo !== 'Ferias' || !!v || 'Informe a data de fim']"
										/>
									</template>
									<v-date-picker v-model="form.data_fim" @input="menuFim = false" />
								</v-menu>
							</v-col>
						</v-row>
						<v-row v-if="isAtestadoComparecimento">
							<v-col cols="6">
								<v-text-field
								v-model="form.hora_inicio"
								label="Hora inicio"
								type="time"
								outlined
								dense
								:rules="[v => !isAtestadoComparecimento || !!v || 'Informe a hora inicio']"
								/>
							</v-col>
							<v-col cols="6">
								<v-text-field
								v-model="form.hora_fim"
								label="Hora fim"
								type="time"
								outlined
								dense
								:rules="[v => validarHoraFim(v)]"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="8">
								<v-autocomplete
								:items="funcionarios"
								item-text="nome"
								item-value="idfuncionarios"
								label="Funcionário"
								v-model="form.idfunc"
								:multiple="isMultiFuncionario"
								:chips="isMultiFuncionario"
								:deletable-chips="isMultiFuncionario"
								clearable
								outlined
								dense
								:rules="[v => validateFuncionario(v)]"
								/>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>

				<v-card-actions>
					<v-spacer />
					<v-btn text @click="onCancel">Cancelar</v-btn>
					<v-btn color="primary" :loading="saving" @click="onSave">Salvar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card flat>
			<v-card-title class="grey--text text--darken-2 font-weight-regular">
				Gerenciamento Agendamentos
				<v-spacer />

				<!-- (Opcional) depois você pode reativar o modo calendário aqui -->
				<v-btn-toggle v-model="viewMode" mandatory>
					<v-btn small value="agenda">
						<v-icon>mdi-format-list-bulleted</v-icon>
					</v-btn>
				</v-btn-toggle>
			</v-card-title>

			<v-divider />

			<v-card-text class="pt-4 pb-2">
				<v-row dense align="center">
					<v-col cols="12" md="3">
						<v-select v-model="filtroMes" :items="meses" item-text="text" item-value="value" label="Mês" outlined dense hide-details/>
					</v-col>

					<v-col cols="12" md="4">
						<v-autocomplete v-model="filtroFuncionario" :items="funcionarios" item-text="nome" item-value="idfuncionarios" label="Funcionário" outlined dense clearable hide-details/>
					</v-col>

					<v-col cols="12" md="3">
						<v-select v-model="filtroTipo" :items="tiposFiltro" item-text="text" item-value="value" label="Tipo" outlined dense clearable hide-details/>
					</v-col>

					<v-col cols="12" md="2">
						<v-text-field v-model="searchText" label="Buscar" outlined dense clearable hide-details prepend-inner-icon="mdi-magnify"/>
					</v-col>
				</v-row>

				<div class="d-flex align-center mt-3">
					<div class="text-caption grey--text">
						Mostrando <strong>{{ filteredEvents.length }}</strong> agendamentos
						<span v-if="filtroMes"> no mês <strong>{{ nomeMes(filtroMes) }}</strong></span>
					</div>
					<v-spacer />
					<v-btn text small @click="clearFilters">
						<v-icon small class="mr-1">mdi-filter-remove</v-icon>
						Limpar filtros
					</v-btn>
				</div>
			</v-card-text>

			<v-divider />

			<!-- AGENDA -->
			<v-sheet class="agenda-shell">
				<div v-if="!groupedAgenda.length" class="empty-state">
					<v-icon large class="mb-2">mdi-calendar-blank</v-icon>
					<div class="text-subtitle-1 font-weight-medium">Nada por aqui</div>
					<div class="text-caption grey--text">
						Ajuste os filtros ou crie um novo agendamento.
					</div>
				</div>

				<v-expansion-panels v-else multiple flat accordion class="agenda-panels">
					<v-expansion-panel v-for="day in groupedAgenda" :key="day.date" class="agenda-day">
						<v-expansion-panel-header class="agenda-day-header">
							<div class="d-flex align-center w-100">
								<div class="day-badge">
									<div class="day-dow">{{ day.dow }}</div>
									<div class="day-num">{{ day.day }}</div>
								</div>

								<div class="ml-3">
									<div class="text-subtitle-2 font-weight-medium">
										{{ day.label }}
									</div>
									<div class="text-caption grey--text">
										{{ day.items.length }} agendamento(s)
									</div>
								</div>

								<v-spacer />

								<!-- chip resumo -->
								<v-chip small label class="mr-2">
									{{ day.items.length }}
								</v-chip>
							</div>
						</v-expansion-panel-header>

						<v-expansion-panel-content class="agenda-day-content">
							<div v-for="ev in day.items" :key="agendaKey(ev)" class="agenda-item" @click="openEventDetails(ev)">
								<div class="agenda-dot" :style="{ backgroundColor: ev.color }"></div>

								<div class="agenda-main">
									<div class="agenda-title">
										<span class="agenda-name">{{ ev.nome || '(Sem nome)' }}</span>

										<v-chip x-small label class="ml-2" :class="chipClassByTipo(ev.tipo)">
											<v-icon x-small class="mr-1">
												{{ getEventIcon(ev.tipo) }}
											</v-icon>
											{{ formatTipo(ev.tipo) }}
										</v-chip>

										<!-- status se existir -->
										<v-chip v-if="ev.status" x-small label class="ml-2" :class="chipClassByStatus(ev.status)">
											{{ ev.status }}
										</v-chip>
									</div>

									<div class="agenda-sub">
										<span v-if="ev.end && ev.end !== ev.start">
											{{ formatoData(ev.start) }} → {{ formatoData(ev.end) }}
										</span>
										<span v-else>
											{{ formatoData(ev.start) }}
										</span>
									</div>
								</div>

								<v-spacer />

								<div class="agenda-actions">
									<!-- Abrir -->
									<v-tooltip bottom open-delay="200">
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon v-bind="attrs" v-on="on" @click.stop="openEventDetails(ev)" :disabled="!temPermissaoAgendamentos">
												<v-icon>mdi-open-in-new</v-icon>
											</v-btn>
										</template>
										<span>Abrir</span>
									</v-tooltip>

									<!-- Excluir -->
									<v-tooltip bottom open-delay="200">
										<template v-slot:activator="{ on, attrs }">
											<v-btn
											icon
											v-bind="attrs"
											v-on="on"
											@click.stop="confirmDelete(ev)"
											:disabled="!temPermissaoAgendamentos"
											>
											<v-icon color="error">mdi-trash-can</v-icon>
										</v-btn>

									</template>
									<span>Excluir</span>
								</v-tooltip>
							</div>

						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-sheet>
	</v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import PageTitle from '@/templates/PageTitle'
import moment from 'moment'

export default {
	name: 'TheAgendamentos',
	components: { PageTitle },
	data() {
		return {
			viewMode: 'agenda',
			filtroTipo: null,
			searchText: '',
			funcionarios: [],
			events: [],
			ferias: [],
			folgas: [],
			isDisabled: false,
			dialog: false,
			calendarValue: new Date().toISOString().substr(0, 10),
			form: {},
			modo: '',
			permissao: false,
			saving: false,
			menuInicio: false,
			menuFim: false,
			filtroMes: new Date().getMonth() + 1,
			filtroFuncionario: null,
			meses: [
				{ text: 'Janeiro', value: 1 },
				{ text: 'Fevereiro', value: 2 },
				{ text: 'Março', value: 3 },
				{ text: 'Abril', value: 4 },
				{ text: 'Maio', value: 5 },
				{ text: 'Junho', value: 6 },
				{ text: 'Julho', value: 7 },
				{ text: 'Agosto', value: 8 },
				{ text: 'Setembro', value: 9 },
				{ text: 'Outubro', value: 10 },
				{ text: 'Novembro', value: 11 },
				{ text: 'Dezembro', value: 12 }
				],
			tipos: [
				{ text: 'Folga', value: 'Folga' },
				{ text: 'Folga Feriado', value: 'Folga Feriado' },
				{ text: 'Feriado', value: 'Feriado' },
				{ text: 'Atestado Dia', value: 'Atestado Dia' },
				{ text: 'Atestado Comparecimento', value: 'Atestado Comparecimento' },
				{ text: 'Compensado na semana', value: 'Acordo' },
				{ text: 'Abatimento no Salário', value: 'Desconto Salário' },
				{ text: 'Férias', value: 'Ferias' }
				]
		}
	},
	computed: {
		...mapState(['user']),

		bloquearEdicaoPorData() {
			return false
		},

		temPermissaoAgendamentos() {
			const tipo = String(this.user?.tipo || '').trim().toLowerCase()
			const perfisLiberados = ['master', 'admin', 'gerente', 'financeiro', 'coordenador', 'supervisor']

			if (perfisLiberados.includes(tipo)) 
				return true

			return this.user?.perm_agendamentos === 1 ||
			this.user?.perm_agendamentos === true ||
			this.user?.perm_agendamentos === '1' ||
			this.user?.agendamentos === 1 ||
			this.user?.agendamentos === true ||
			this.user?.agendamentos === '1'
		},

		tiposFiltro() {
	// mesmo “tipos”, mas com texto amigável
			return this.tipos.map(t => ({
				...t,
				text: this.formatTipo(t.value),
			}))
		},

		filteredEvents() {
			const mes = Number(this.filtroMes)
			const func = this.filtroFuncionario
			const tipo = this.filtroTipo
			const q = (this.searchText || '').trim().toLowerCase()

			return (this.events || [])
			.filter(ev => {
			// garante start
				if (!ev.start)
					return false

			// filtro mês
				if (mes) {
					const inicio = moment(ev.start, 'YYYY-MM-DD')
					const fim = ev.end ? moment(ev.end, 'YYYY-MM-DD') : inicio
					let cursor = inicio.clone().startOf('month')
					const limite = fim.clone().startOf('month')
					let pertenceAoMes = false

					while (cursor.isSameOrBefore(limite)) {
						if (cursor.month() + 1 === mes) {
							pertenceAoMes = true
							break
						}
						cursor.add(1, 'month')
					}

					if (!pertenceAoMes) 
						return false
				}

			// filtro funcionário
				if (func && String(ev.idfunc) !== String(func)) 
					return false

			// filtro tipo
				if (tipo && ev.tipo !== tipo) 
					return false

			// busca textual
				if (q) {
					const hay = `${ev.nome || ''} ${ev.tipo || ''} ${ev.status || ''} ${ev.hora_inicio || ''} ${ev.hora_fim || ''}`.toLowerCase()
					if (!hay.includes(q)) 
						return false
				}

				return true
			})
			.sort((a, b) => {
			// ordena por data e depois nome
				const da = a.start || ''
				const db = b.start || ''
				if (da < db) 
					return -1
				if (da > db) 
					return 1
				return (a.nome || '').localeCompare(b.nome || '')
			})
		},

		totalAbatimentosSalario() {
			return (this.folgas || []).filter(f => f.tipo === 'Desconto Salário').length
		},

		groupedAgenda() {
	// agrupa por dia (start)
			const map = new Map()

			for (const ev of this.filteredEvents) {
				const d = ev.start
				if (!map.has(d)) 
					map.set(d, [])
				map.get(d).push(ev)
			}

			const days = Array.from(map.entries())
			.sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
			.map(([date, items]) => {
				const m = moment(date, 'YYYY-MM-DD')
				return {
					date,
					day: m.format('DD'),
					dow: m.format('ddd').toUpperCase(),
					label: m.format('DD/MM/YYYY'),
					items
				}
			})

			return days
		},
		dialogTitle() {
			if (this.form && this.form.id) 
				return 'Editar Agendamento'
			return 'Novo Agendamento'
		},
		isMultiFuncionario() {
			return this.form && (this.form.tipo === 'Feriado' || this.form.tipo === 'Folga Feriado')
		},
		isAtestadoComparecimento() {
			return this.form && this.form.tipo === 'Atestado Comparecimento'
		},

	},
	watch: {
		'form.tipo'(novo) {
			if (!this.form) 
				return

			const isMulti = (novo === 'Feriado' || novo === 'Folga Feriado')

			if (isMulti) {
				if (this.form.idfunc && !Array.isArray(this.form.idfunc)) {
					this.form.idfunc = [this.form.idfunc]
				} else if (!this.form.idfunc) {
					this.form.idfunc = []
				}
			} else {
				if (Array.isArray(this.form.idfunc)) {
					this.form.idfunc = this.form.idfunc[0] || null
				}
			}

			if (novo !== 'Atestado Comparecimento') {
				this.form.hora_inicio = null
				this.form.hora_fim = null
			}
		}
	},
	methods: {
		async confirmDelete(ev) {
			try {
				if (!this.temPermissaoAgendamentos) 
					return

				const ok = window.confirm(
					`Excluir este agendamento?\n\n${ev.nome || ''} • ${this.formatTipo(ev.tipo)} • ${this.formatoData(ev.start)}`
					)
				if (!ok) 
					return

				await this.deleteEvent(ev)
			} catch (err) {
				showError(err)
			}
		},


		async deleteEvent(ev) {
			try {
				this.saving = true

    // Férias vai para /ferias/:id, o resto vai para /folgas/:id
				if (ev.tipo === 'Ferias') {
					await axios.delete(`${baseApiUrl}/ferias/${ev.id}`)
					this.$toasted.success('Férias excluída com sucesso!')
					await this.loadFerias()
				} else {
					await axios.delete(`${baseApiUrl}/folgas/${ev.id}`)
					this.$toasted.success('Agendamento excluído com sucesso!')
					await this.loadFolgas()
				}

				this.refreshEvents()
			} catch (err) {
				const msg =
				err?.response?.data?.message ||
				err?.response?.data ||
				err?.message ||
				'Erro ao excluir.'
				this.$toasted.show(msg, { type: 'danger', duration: 4500 })
				showError(err)
			} finally {
				this.saving = false
			}
		},

		validateFuncionario(v) {
			if (this.isMultiFuncionario) {
				return (Array.isArray(v) && v.length > 0) || 'Selecione ao menos 1 colaborador'
			}
			return !!v || 'Selecione o colaborador'
		},

		horaParaMinutos(value) {
			if (!value) return null
			const partes = String(value).slice(0, 5).split(':').map(Number)
			if (partes.length < 2 || partes.some(Number.isNaN)) return null
			return (partes[0] * 60) + partes[1]
		},

		validarHoraFim(value) {
			if (!this.isAtestadoComparecimento) return true
			if (!value) return 'Informe a hora fim'
			const inicio = this.horaParaMinutos(this.form.hora_inicio)
			const fim = this.horaParaMinutos(value)
			if (inicio === null || fim === null) return 'Informe um horario valido'
			return fim > inicio || 'Hora fim deve ser maior que hora inicio'
		},

		normalizeIdfunc(value) {
			if (this.isMultiFuncionario) {
				if (!value) 
					return []
				return Array.isArray(value) ? value : [value]
			}
			if (Array.isArray(value)) 
				return value[0] || null
			return value || null
		},

		formatTipo(tipo) {
			switch (tipo) {
			case 'Folga Feriado': return 'Folga Feriado'
			case 'Atestado': return 'Atestado Dia'
			case 'Atestado Dia': return 'Atestado Dia'
			case 'Atestado Comparecimento': return 'Atestado Comparecimento'
			case 'Desconto Salário': return 'Abatimento no Salário'
			case 'Ferias': return 'Férias'
			default: return tipo
			}
		},

		nomeMes(value) {
			const m = this.meses.find(x => Number(x.value) === Number(value))
			return m ? m.text : ''
		},

		clearFilters() {
			this.filtroFuncionario = null
			this.filtroTipo = null
			this.searchText = ''
	// mantém o mês, normalmente é útil; se quiser limpar mês também:
	// this.filtroMes = new Date().getMonth() + 1
		},

		agendaKey(ev) {
			return `${ev.tipo}-${ev.id}-${ev.start}-${ev.end || ''}-${ev.idfunc || ''}-${ev.nome || ''}`
		},

		chipClassByTipo(tipo) {
			switch (tipo) {
			case 'Feriado': return 'chip-tipo chip-feriado'
			case 'Folga': return 'chip-tipo chip-folga'
			case 'Folga Feriado': return 'chip-tipo chip-folga'
			case 'Atestado': return 'chip-tipo chip-atestado'
			case 'Atestado Dia': return 'chip-tipo chip-atestado'
			case 'Atestado Comparecimento': return 'chip-tipo chip-atestado'
			case 'Desconto Salário': return 'chip-tipo chip-desconto-salario'
			case 'Ferias': return 'chip-tipo chip-ferias'
			default: return 'chip-tipo'
			}
		},

		chipClassByStatus(status) {
			const s = (status || '').toLowerCase()
			if (s.includes('aprov')) 
				return 'chip-status chip-ok'
			if (s.includes('pend')) 
				return 'chip-status chip-warn'
			if (s.includes('reprov') || s.includes('recus')) 
				return 'chip-status chip-bad'
			return 'chip-status'
		},

		isPastDate(date) {
			const hoje = moment().startOf('day')
			const data = moment(date, 'YYYY-MM-DD').startOf('day')
			return data.isBefore(hoje)
		},
		getEventIcon(tipo) {
			switch (tipo) {
			case 'Folga':
				return 'mdi-calendar-remove'
			case 'Folga Feriado':
				return 'mdi-calendar-remove'
			case 'Feriado':
				return 'mdi-calendar-remove'
			case 'Ferias':
				return 'mdi-beach'
			case 'Atestado':
			case 'Atestado Dia':
				return 'mdi-file-document-check-outline'
			case 'Atestado Comparecimento':
				return 'mdi-clock-check-outline'
			case 'Desconto Salário':
				return 'mdi-cash-minus'
			default:
				return 'mdi-calendar'
			}
		},

		openEventDetails(event) {
			if (!this.temPermissaoAgendamentos) 
				return

			if (this.bloquearEdicaoPorData && this.isPastDate(event.start)) {
				this.$toasted.show('Não é possível editar agendamentos cuja data já passou.', {
					type: 'danger',
					duration: 4000,
					className: 'toast-orange'
				})
				return
			}

			if (event.tipo === 'Ferias') {
				this.openEditFeria(event)
				return
			}

			if ((event.tipo === 'Folga' || event.tipo === 'Folga Feriado' || event.tipo === 'Feriado' || event.tipo === 'Atestado' || event.tipo === 'Atestado Dia' || event.tipo === 'Atestado Comparecimento' || event.tipo === 'Acordo' || event.tipo === 'Desconto Salário') && this.temPermissaoAgendamentos) {
				this.openEditFolga(event)
			} else if (event.tipo === 'Ferias' && event.status === 'Gozada') {
				this.openEditFeria(event)
			}
		},

		async loadFolgas() {
			try {
				const res = await axios.get(`${baseApiUrl}/folgas`)
				this.folgas = res.data.map(fo => ({
					id: fo.idfolgas,
					tipo: fo.tipo,
					nome: fo.nome || '',
					start: moment(fo.data_inicio).format('YYYY-MM-DD'),
					end: fo.data_fim ? moment(fo.data_fim).format('YYYY-MM-DD') : null,
					color: fo.cor,
					status: fo.status,
					fstatus: fo.fstatus,
					idfunc: fo.idfuncionarios,
					hora_inicio: fo.hora_inicio ? String(fo.hora_inicio).slice(0, 5) : null,
					hora_fim: fo.hora_fim ? String(fo.hora_fim).slice(0, 5) : null
				}))
				this.refreshEvents()
			} catch (err) {
				showError(err)
			}
		},
		async loadFerias() {
			try {
				const res = await axios.get(`${baseApiUrl}/ferias`)
				this.ferias = res.data.map(ev => ({
					id: ev.idferias,
					tipo: 'Ferias',
					nome: ev.nome ? ev.nome.split(' ')[0] : '',
					start: moment(ev.data_inicio).format('YYYY-MM-DD'),
					end: ev.data_fim ? moment(ev.data_fim).format('YYYY-MM-DD') : null,
					color: ev.cor,
					status: ev.status,
					idfunc: ev.idfuncionarios
				}))
				this.refreshEvents()
			} catch (err) {
				showError(err)
			}
		},

		refreshEvents() {
			this.events = [
				...this.folgas.map(f => ({ ...f })),
				...this.ferias.map(f => ({ ...f }))
				]
		},

		openCreateDialog() {
			this.modo = 'save'
			this.loadFuncionarios()
			this.dialog = true
			this.isDisabled = false
			this.form = {}
		},

		openEditFolga(item) {
			if (this.bloquearEdicaoPorData && this.isPastDate(item.start)) {
				this.$toasted.info('Não é possível editar folgas cuja data já passou.')
				return
			}
			this.modo = 'edit'
			this.loadFuncionarios()
			this.dialog = true
			this.isDisabled = false
			this.form = {
				id: item.id,
				tipo:item.tipo,
				data_inicio: item.start,
				cor: item.color,
				idfunc: (item.tipo === 'Feriado' || item.tipo === 'Folga Feriado') ? [item.idfunc] : item.idfunc,
				hora_inicio: item.hora_inicio || null,
				hora_fim: item.hora_fim || null



			}
		},

		openEditFeria(item) {
			if (this.bloquearEdicaoPorData && this.isPastDate(item.start)) {
				this.$toasted.info('Não é possível editar férias cuja data de início já passou.')
				return
			}
			this.modo = 'edit'
			this.loadFuncionarios()
			this.dialog = true
			this.isDisabled = false
			this.form = {
				id: item.id,
				tipo: 'Ferias',
				data_inicio: item.start,
				data_fim: item.end,
				cor: item.color,
				idfunc: item.idfunc
			}
		},

		loadFuncionarios() {
			axios
			.get(`${baseApiUrl}/usuarios?status=ativos`)
			.then(res => (this.funcionarios = res.data))
			.catch(showError)
		},

		async onSave() {
			const formRef = this.$refs.form
			if (formRef && formRef.validate && !formRef.validate()) 
				return

			try {
				this.saving = true

    // =========================
    // FOLGAS / FERIADOS / ACORDO /ATESTADO / OUTROS
    // =========================
				if (
					this.form.tipo === 'Folga' ||
					this.form.tipo === 'Folga Feriado' ||
					this.form.tipo === 'Feriado' ||
					this.form.tipo === 'Atestado' ||
					this.form.tipo === 'Atestado Dia' ||
					this.form.tipo === 'Atestado Comparecimento' ||
					this.form.tipo === 'Acordo' ||
					this.form.tipo === 'Desconto Salário'
					) {
					if (!this.form.data_inicio) 
						throw new Error('Informe a data')

      // Multi apenas para Feriado e Folga Feriado
					const isMulti =
					this.form.tipo === 'Feriado' || this.form.tipo === 'Folga Feriado'

      // EDITAR: nunca em lote
					if (this.form.id) {
						const payload = {
							...this.form,
							idfunc: Array.isArray(this.form.idfunc)
							? this.form.idfunc[0]
							: this.form.idfunc
						}

						await axios.put(`${baseApiUrl}/folgas/${this.form.id}`, payload)

					} else {
        // CRIAR
						if (isMulti) {
          // ====== BULK ======
							if (!Array.isArray(this.form.idfunc) || !this.form.idfunc.length) {
								throw new Error('Selecione ao menos 1 colaborador')
							}

							const payload = {
								tipo: this.form.tipo,
								data_inicio: this.form.data_inicio,
								cor: this.form.cor,
								status: this.form.status,
								idfunc: this.form.idfunc
							}

							await axios.post(`${baseApiUrl}/folgas/bulk`, payload)

						} else {
          // ====== SINGLE ======
							if (!this.form.idfunc) 
								throw new Error('Selecione o colaborador')

							const payload = {
								...this.form,
								idfunc: this.form.idfunc
							}

							await axios.post(`${baseApiUrl}/folgas`, payload)
						}
					}

					this.$toasted.global.defaultSuccess()
					await this.loadFolgas()
					this.reset()
					return
				}

    // =========================
    // FÉRIAS
    // =========================
				if (this.form.tipo === 'Ferias') {
					if (!this.form.data_inicio || !this.form.data_fim) {
						throw new Error('Informe o período')
					}
					if (!this.form.idfunc) {
						throw new Error('Selecione o colaborador')
					}

					const metodo = this.form.id ? 'put' : 'post'
					const id = this.form.id ? `/${this.form.id}` : ''

					const payload = {
						data_inicio: this.form.data_inicio,
						data_fim: this.form.data_fim,
						cor: this.form.cor,
						status: this.form.status,
						idfunc: this.form.idfunc
					}

					await axios[metodo](`${baseApiUrl}/ferias${id}`, payload)

					this.$toasted.global.defaultSuccess()
					await this.loadFerias()
					this.reset()
					return
				}

    // Se cair aqui, é porque escolheu tipo não tratado
				throw new Error('Tipo de agendamento inválido ou não suportado.')

			} catch (err) {console.log(err)
			const msg =
			err?.response?.data?.message ||
			err?.response?.data ||
			err?.message ||
			'Erro ao salvar.'
			this.$toasted.show(msg, { type: 'danger', duration: 4500 })
			showError(err)
		} finally {
			this.saving = false
		}
	},

	onCancel() {
		this.reset()
	},

	reset() {
		this.dialog = false
		this.form = {}
      // não limpamos listas, apenas o dialog e o form
      // reconstruir eventos (caso tenha sido alterado)
		this.refreshEvents()
	},

	formatoData(data) {
		if (data) 
			return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY')
		return ''
	}
},

async mounted() {
	this.permissao = this.temPermissaoAgendamentos
	await Promise.all([this.loadFolgas(), this.loadFerias(), this.loadFuncionarios()])
	this.refreshEvents()
}
}
</script>


<style scoped>
.agenda-shell {
	height: 720px;
	overflow: auto;
	padding: 12px;
}

.empty-state {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	opacity: 0.85;
	text-align: center;
	padding: 24px;
}

.agenda-day {
	border-radius: 10px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 1px 2px rgba(0,0,0,0.06);
	margin-bottom: 10px;
}

.agenda-day-header {
	background: rgba(0,0,0,0.02);
}

.day-badge {
	width: 48px;
	height: 48px;
	border-radius: 12px;
	background: rgba(0,0,0,0.06);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	line-height: 1;
}

.day-dow {
	font-size: 10px;
	font-weight: 700;
	color: rgba(0,0,0,0.55);
	letter-spacing: 0.6px;
}

.day-num {
	font-size: 16px;
	font-weight: 800;
	color: rgba(0,0,0,0.75);
	margin-top: 4px;
}

.agenda-day-content {
	padding-top: 6px;
	padding-bottom: 10px;
}

.agenda-item {
	display: flex;
	align-items: center;
	padding: 10px 10px;
	border-radius: 10px;
	cursor: pointer;
	transition: background 0.15s, box-shadow 0.15s, transform 0.15s;
	margin: 6px 6px;
	background: rgba(0,0,0,0.02);
}

.agenda-item:hover {
	background: rgba(0,0,0,0.03);
	box-shadow: 0 2px 10px rgba(0,0,0,0.10);
	transform: translateY(-1px);
}

.agenda-dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	margin-right: 10px;
	flex: 0 0 auto;
}

.agenda-main {
	min-width: 0;
	flex: 1;
}

.agenda-title {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 6px;
	min-width: 0;
}

.agenda-name {
	font-weight: 700;
	color: rgba(0,0,0,0.82);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 260px;
}

.agenda-sub {
	font-size: 12px;
	color: rgba(0,0,0,0.58);
	margin-top: 3px;
}

.agenda-actions {
	display: flex;
	align-items: center;
	opacity: 0.7;
}

.agenda-item:hover .agenda-actions {
	opacity: 1;
}

/* Chips */
.chip-tipo {
	background: rgba(0,0,0,0.06) !important;
}

.chip-ferias { background: rgba(0, 150, 136, 0.12) !important; }
.chip-feriado { background: rgba(244, 67, 54, 0.12) !important; }
.chip-folga { background: rgba(33, 150, 243, 0.12) !important; }
.chip-atestado { background: rgba(255, 152, 0, 0.14) !important; }
.chip-desconto-salario { background: rgba(230, 81, 0, 0.14) !important; }
.chip-outros { background: rgba(156, 39, 176, 0.12) !important; }

.chip-status {
	background: rgba(0,0,0,0.06) !important;
}

.chip-ok { background: rgba(76, 175, 80, 0.14) !important; }
.chip-warn { background: rgba(255, 193, 7, 0.18) !important; }
.chip-bad { background: rgba(244, 67, 54, 0.14) !important; }
</style>

